import React from 'react';
import {Avatar, Box, Button, Card} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import Typography from '@mui/material/Typography';
import '../../../view/Landing/Header/Header.scss'

const Logo = require('../../../assets/Images/DCDDLogo.png');
const Logo2 = require('../../../assets/Images/headerLogo2.png');

export default function Login() {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Box sx={{height: '100vh', backgroundColor: '#E9EFFB'}}>
        <Box sx={{height: {xs: 150, sm: 250}, ml: {sm: 12, xs: 2}, mr: {sm: 12, xs: 2}}} className="headerContent">
          <Box sx={{display: 'flex', alignItems: 'center'}}>
            <img draggable={false} style={{margin: 12}} className="hand-cursor logo-design"
                 onClick={() => navigate('/')}
                 src={Logo}
                 alt="logo"/>
          </Box>
          <Box className={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
            <Typography className={'loginTitle'}>
              MUSEUM COLLECTION MANAGEMENT
            </Typography>
            <Typography className={'loginTitle'}>
              &
            </Typography>
            <Typography className={'loginTitle'}>
              VISITOR MANAGEMENT SYSTEM
            </Typography>
          </Box>
          <Box sx={{display: 'flex', alignItems: 'center'}}>
            <img draggable={false} style={{margin: 12}} className="hand-cursor logo-design"
                 onClick={() => navigate('/')}
                 src={Logo2}
                 alt="logo2"/>
          </Box>
        </Box>
        <Box className={'loginDivider'}/>
        <Box display={'flex'} flexDirection={'row'} justifyContent={'center'}>
          <Card className={'box-shadow2'} sx={{p: 4, mt: 5}}>
            <Typography textAlign={'center'}>
              Click to login through
            </Typography>
            <Typography textAlign={'center'} sx={{mb: 5}}>
              National Digital Identity (NDI)
            </Typography>
            <Button onClick={() => navigate('/login-with-ndi')} startIcon={
              <Avatar sx={{width: 40}} src={require('../../../assets/Images/ndilogo.png')}/>}
                    variant={'container'}
                    sx={{
                      backgroundColor: '#124143',
                      color: '#fff',
                      textTransform: 'capitalize',
                      pl: 4, pr: 4,
                      '&:hover': {backgroundColor: '#164244'},
                      mb: 1
                    }}>
              Login with Bhutan NDI
            </Button>
            <div className="dashed-design">
              <div className="divider"/>
              <div className="text">or</div>
              <div className="divider"/>
            </div>
            <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
              <Button onClick={() => navigate('/agency-login')}
                sx={{
                  backgroundColor: '#2a9da2',
                  color: '#fff',
                  textTransform: 'capitalize',
                  pl: 4, pr: 4,
                  '&:hover': {backgroundColor: '#38bcc2'},
                  mt: 1
                }}>
                Agency login
              </Button>
              <Typography onClick={() => navigate('/')} className={'hand-cursor'} sx={{mt: 3, mb: 3}}>Back To Home</Typography>
            </Box>
          </Card>
        </Box>
      </Box>
    </React.Fragment>
  );
}